<template>
  <div>
    <div class="mb-3 d-flex align-items-center justify-content-end">
      <strong class="text-body text-dark mr-2">
        Score:
        <div class="d-inline-block" style="width: 30px">{{ point }}</div>
      </strong>

      <star-rating :item-size="20" :increment="0.5" :show-rating="false" v-model="point" :readOnly="disabled" />
    </div>
    <b-form-textarea
      rows="4"
      placeholder="What should I do to get better?"
      v-model="comment"
      :disabled="!point || disabled"
    ></b-form-textarea>
  </div>
</template>

<script>
import { StarRating } from 'vue-rate-it';
export default {
  name: 'CreateReviewPointForm',
  components: { StarRating },
  data() {
    return {
      point: this.reviewPoint.point,
      comment: this.reviewPoint.comment,
      bounce: null,
    };
  },
  props: {
    reviewPoint: {
      type: Object,
      required: true,
    },
    debounceTime: {
      type: Number,
      default: 2000,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleChange() {
      if (!this.point) return;

      this.$emit('onSubmit', {
        point: this.point,
        comment: this.comment,
      });
    },
    debounce() {
      const t = this;
      if (t.bounce) {
        clearTimeout(t.bounce);
      }

      t.bounce = setTimeout(() => {
        t.handleChange();
        t.bounce = null;
      }, t.debounceTime);
    },
  },
  watch: {
    point: function(v, oV) {
      if (v === oV) return;
      this.debounce();
    },
    comment: function(v, oV) {
      if (v === oV) return;
      this.debounce();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/colors';

strong {
  color: $darkBlue !important;
}

textarea {
  font-size: 1.6rem;
}
</style>
